<template>
  <v-snackbar
    v-model="internalSnackbar"
    color="primary"
    :timeout="timeout"
    :style="{ 'margin-bottom': `${margin}px` }"
    persistent
  >
    <div v-if="success">
      <span v-if="success.status === 201"> Item created successfully! </span>
      <span v-else-if="success.status === 200"> Item updated successfully! </span>
      <span v-else-if="success.status === 202">
        Accepted! {{ success.data ? success.data : null }}
      </span>
      <span v-else-if="success.status === 204"> Item deleted successfully! </span>
      <v-chip label variant="outlined" size="small" color="primary" class="ml-2">
        {{ success.status }}
      </v-chip>
    </div>
    <template #actions>
      <v-btn
        icon
        size="small"
        color="primary"
        variant="text"
       @click="internalSnackbar = false"
      >
        <v-icon size="small"> mdi-close-circle</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>
<script>
  export default {
    name: "SuccessSnackbar",
    props: {
      success: {},
      snackbar: {},
      margin: { required: false, default: 0 },
      timeout: { required: false, default: 4000 }
    },
    computed: {
      internalSnackbar: {
        get () {
          return this.snackbar
        },
        set () {
          this.$emit("set")
        }
      }
    }
  }
</script>
